import createReducer from './create-reducer';
import DEFAULT_STATE from '../defaults/device';

export default createReducer(DEFAULT_STATE, {});
